export const NAME_COLLISION_MEMBER_TYPES = {
  SUBCATEGORIES: 'subCategories',
  PROPERTIES: 'properties',
  EVENTS: 'events',
  OPERATIONS: 'operations',
  CLIENT_EVENTS: 'clientEvents',
  MESSAGES: 'messages',
  GUIDES: 'relatedGuides',
};

export const NAME_COLLISION_CONFIG_ERRORS = {
  TEXT_PLACEMENT_MISSING: (memberType) =>
    `Config error: resolvingNameConflicts: ${memberType}: additionalText is inserted but textPlacement is missing.`,
  ADDITIONAL_TEXT_MISSING: (memberType) =>
    `Config error: resolvingNameConflicts: ${memberType}: textPlacement is inserted but additionalText is missing.`,
  TEXT_PLACEMENT_WRONG_VALUE: (memberType, textPlacement) =>
    `Invalid value in "textPlacement" was inserted to ${memberType} - ${textPlacement}. Please check the config.`,
};

export class InvalidValueInCollisionConfig extends Error {
  constructor(memberType, textPlacement) {
    super(
      NAME_COLLISION_CONFIG_ERRORS.TEXT_PLACEMENT_WRONG_VALUE(
        memberType,
        textPlacement,
      ),
    );
    this.name = 'InvalidValueInCollisionConfig';
  }
}

export class MissingTextPlacementCollisionConfig extends Error {
  constructor(memberType) {
    super(NAME_COLLISION_CONFIG_ERRORS.TEXT_PLACEMENT_MISSING(memberType));
    this.name = 'MissingTextPlacementCollisionConfig';
  }
}

export class MissingAdditionalTextCollisionConfig extends Error {
  constructor(memberType) {
    super(NAME_COLLISION_CONFIG_ERRORS.ADDITIONAL_TEXT_MISSING(memberType));
    this.name = 'MissingAdditionalTextCollisionConfig';
  }
}
